<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>ESG Assurance Providers</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCsrAssuranceProviderCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateCsrAssuranceProvider()">
        <mat-icon>add</mat-icon>
        Add ESG Assurance Provider
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="csrAssuranceProviders()"
      [enablePaging]="true"
      [enableMatching]="true"
      [pageSize]="25"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCsrAssuranceProvider($event)"
      (deleteClick)="onDeleteCsrAssuranceProvider($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
